import React from 'react';

import { ReactComponent as TimeIcon } from '../../assets/icons/timer-icon.svg';
import CustomInput from '../custom-input/CustomInput';

interface CustomInputProperties {
  inputLabel?: string;
  onChangeValue: (name: string, value: string | number) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  hourValue: string;
  minutesValue: string;
  error?: boolean;
  errorMessage?: string;
}

/**
 * File upload input box
 */
function CustomHoursLimit({
  inputLabel,
  onChangeValue,
  valueRequired,
  hourValue,
  minutesValue,
  readOnly,
  error,
  errorMessage,
}: CustomInputProperties) {
  return (
    <div className="custom-hours-limit-wrap">
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel} 
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-hours-limit">
        <CustomInput
          name="hour"
          placeholder=""
          onChangeValue={onChangeValue}
          type="text"
          value={hourValue}
          frondIcon={<TimeIcon />}
          svgIcon={<div className="grey-text">Hrs</div>}
          readOnly={readOnly}
        />
        <CustomInput
          name="minutes"
          placeholder=""
          onChangeValue={onChangeValue}
          type="text"
          frondIcon={<TimeIcon />}
          svgIcon={<div className="grey-text">Min</div>}
          value={minutesValue}
        />
        <p>Per (Day)</p>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomHoursLimit.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  errorMessage: '',
};

export default CustomHoursLimit;
